var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoutMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.007H2c-.733 0-1.333.6-1.333 1.333V6H2V3.327h12v9.353H2V10H.667v2.673c0 .734.6 1.32 1.333 1.32h12c.733 0 1.333-.586 1.333-1.32V3.34c0-.74-.6-1.333-1.333-1.333zm-6.667 8.66L10 8 7.333 5.333v2H.667v1.334h6.666v2z",
    fill: "currentColor"
  })));
}

export default SvgLogoutMobile;